import { cn } from '../../lib/cn'

interface EmptyStateProps {
  title?: string
  description: string
  action?: React.ReactNode
  /** Dashed panel (browse/circle no-results) vs plain inline copy. */
  dashed?: boolean
  className?: string
}

export function EmptyState({ title, description, action, dashed, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        dashed
          ? 'rounded-card border border-dashed border-line px-5 py-8 text-center'
          : 'px-1 py-4',
        className,
      )}
    >
      {title && <div className="mb-1 text-[14px] font-medium text-ink">{title}</div>}
      <p className="text-[13px] leading-relaxed text-ink-muted">{description}</p>
      {action && <div className={cn('mt-4', dashed && 'flex justify-center')}>{action}</div>}
    </div>
  )
}
